import React, { useEffect, useState } from "react";
import { Form, Input } from "antd";
import toast from "react-hot-toast";
import LoadableButton from "../../../components/button/LoadableButton";
import ModalComponent from "../../../components/modals/ModalComponent";
import { ChangePasswordApi } from "../../../api/request/settings/settings";
import MpinModal from "../../dashboard/components/MpinModal";

const ResetPassword = ({ email }) => {
  const [form] = Form.useForm();

  const [isResetPassword, setIsResetPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });
  const [passwordVisible, setPasswordVisible] = useState(true);
  const [mpinVisible, setMpinVisible] = useState(false);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    // delete values?.confirm_password;
    try {
      const { data } = await ChangePasswordApi(values);
      if (data?.status) {
        toast.success(data?.message);
        setIsResetPassword(false);
      } else {
        toast.error(data?.message);
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (!isResetPassword) {
      form.resetFields();
      setInitialValues({
        old_password: "",
        new_password: "",
        confirm_password: "",
      });
    }
  }, [isResetPassword]);

  return (
    <>
      <div className="border rounded-lg p-4 grid grid-cols-2">
        <div className="pr-6">
          <p className="title border-b pb-3">Reset Password</p>
          <div className="mt-4 space-y-5">
            <p>
              Click the button below to reset and create a new password for your
              account.
            </p>

            <LoadableButton
              lable="Reset password"
              onClick={() => setIsResetPassword(true)}
            />
          </div>
        </div>

        <div className="pl-6 border-l relative">
          <p className="title border-b pb-3">Reset MPIN</p>
          <div className="mt-4">
            <p>Click the button below to reset MPIN for your account.</p>

            <LoadableButton
              className="max-w-[181px] w-full absolute bottom-0 left-6"
              lable="Reset MPIN"
              onClick={() => setMpinVisible(true)}
            />
          </div>
        </div>
      </div>

      <ModalComponent
        isOpen={isResetPassword}
        setIsOpen={setIsResetPassword}
        title="Reset Password"
      >
        <h4 className="mid-title">
          Please fill in the fields below to proceed with updating your password
        </h4>
        <Form
          autoComplete="off"
          form={form}
          initialValues={initialValues}
          onFinish={handleSubmit}
        >
          <Form.Item
            name="old_password"
            className="mb-0 mt-5"
            rules={[
              {
                required: true,
                message: "Please enter your current password!",
              },
            ]}
          >
            <Input.Password placeholder="current password" size="large" />
          </Form.Item>
          <Form.Item
            name="new_password"
            className="mb-0 mt-5"
            rules={[
              { required: true, message: "Please enter your new password!" },
              {
                pattern:
                  /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/,
                message:
                  "Password must be at least 8 characters, include uppercase, lowercase, number, and special character.",
              },
            ]}
          >
            <Input.Password
              placeholder="New password"
              size="large"
              visibilityToggle={{
                visible: passwordVisible,
                onVisibleChange: setPasswordVisible,
              }}
            />
          </Form.Item>
          <Form.Item
            name="confirm_password"
            className="mb-0 mt-5"
            rules={[
              {
                required: true,
                message: "Please enter your confirm password!",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("new_password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("The new password that you entered do not match!")
                  );
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm password" size="large" />
          </Form.Item>

          <LoadableButton
            className="mt-5 w-full"
            type="submit"
            lable="Change password"
            loadingLable="Updating password..."
            isLoading={isLoading}
          />
        </Form>
      </ModalComponent>

      <MpinModal
        isOpen={mpinVisible}
        setIsOpen={setMpinVisible}
        closable={true}
        updateMpin={true}
      />
    </>
  );
};

export default ResetPassword;
